/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Permission_TextInputs */



/**
* | output |
* | --- |
* | "Please contact your system administrator for help." |
*
* @param {Team_Manager_No_Permission_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_permission_text = /** @type {((inputs?: Team_Manager_No_Permission_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Permission_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez contacter votre administrateur système pour obtenir de l’aide.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wenden Sie sich an Ihren Systemadministrator, um Hilfe zu erhalten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per assistenza, contattare l'amministratore di sistema.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, обратитесь за помощью к системному администратору.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comuníquese con el administrador del sistema para obtener ayuda.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请联系您的系统管理员寻求帮助。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サポートが必要な場合は、システム管理者にお問い合わせください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया सहायता के लिए अपने सिस्टम एडमिनिस्ट्रेटर से संपर्क करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, entre em contato com o administrador do sistema para obter ajuda.")
	return /** @type {LocalizedString} */ ("Please contact your system administrator for help.")
});